module.exports = __webpack_public_path__ + "172f361d28a0ffaa8a72d1192cddfc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard_emails.png
// module id = 55
// module chunks = 0 1 2 3 4